

var Model = require("../types/Model");

module.exports = Model({
	name: "orgusers",
	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,

	recalculate: recalculate,
	addPeople: addPeople,
	setEnd: setEnd,
	trackChanges: trackChanges
});

function triggers(){
	return {
		view: view,
		more: more,
		token: token,
		closetoken: closeToken,
		search: search,
		reset: reset,

		"group:load": handle_group_loaded,
		"group:clear": handle_group_cleared,

		initiateControl: handle_intiate_control
	};
}

function listeners(){
	return {
		"orguserdata:updated": Model.makeRecalculator("people"),
		"orggroup:updated": handle_orggroup_update
	};
}

function recalculate(){
	var people = this._people;
	var rawList = this._rawList;
	var end = this._end;

	var newList = rawList.reduce(function(acc, user){
		var person = people[user];
		if(person)
			acc = acc.concat(person);
		return acc;
	}, []);

	this.extend({
		end: end,
		list: newList
	});
}

function init(){
	this.push({
		list: [],
		end: false,
		token: null,
		query: "",
		initiateControlTarget: null
	});
	this._tracker = this.dispatcher.createTracker();
	this._viewing = false;
	this._orgGroup = null;
	this._page = 0;
	this._end = false;
	this._query = "";
	this._rawList = [];
}

function uninit(){
	this._tracker.off();
	this._tracker = null;
}

function view(){
	var page = this._page;
	var query = this._query;
	this.emit("orguserinvites:trigger:view");
	this.dispatch("viewing");
	this._viewing = true;
	this.emit("usermetrics:trigger:track", "navigate to creation/Token page");
	this.api.org.users.list(query, page)
		.then(handle_users.bind(this))
		.then(trackChanges.bind(this));
}

function handle_users(users){
	var currentList = this._rawList;
	this.setEnd(users);
	this.addPeople(users);
	this._rawList = currentList.concat(users);
	this.recalculate();
}

function more(){
	var query = this._query;
	var page = ++this._page;
	var manageGroup = this._manageGroup;

	var promise = Promise.resolve();
	if(manageGroup)
		promise = this.api.org.users.listByManageGroup(query, manageGroup, page);
	else
		promise = this.api.org.users.list(query, page);

	this.emit("usermetrics:trigger:track", "load more users", {
		group: manageGroup,
		page
	})
	promise.then(handle_users.bind(this));
}

function token(who){
	this.extend({
		token: true
	});
	this.emit("usermetrics:trigger:track", "viewing user token", {
		who: who
	});
	this.api.org.users.token(who)
		.then(handle_token.bind(this));
}

function handle_token(data){
	this.extend({
		token: data.token
	});
}

function closeToken(){
	this.emit("usermetrics:trigger:track", "close user token");
	this.extend({
		token: null
	});
}

function search(query){
	var page = 0;
	this._page = page;
	this._query = query;
	this.extend({
		query: query
	});

	var manageGroup = this._manageGroup;

	var promise = Promise.resolve();
	if(manageGroup)
		promise = this.api.org.users.listByManageGroup(query, manageGroup, page);
	else
		promise = this.api.org.users.list(query, page);

	promise.then(handle_users_search.bind(this));
}

function handle_users_search(users){
	this.setEnd(users);
	this.addPeople(users);
	this._rawList = users;
	this.recalculate();
}

function setEnd(users){
	if(users.length < 32)
		this._end = true;
	else
		this._end = false;
}

function addPeople(users){
	this.emit("orguserdata:trigger:add", {
		lean: true,
		who: users
	});
}

function handle_orggroup_update(orgGroup){
	if(!orgGroup) return;
	this._orgGroup = orgGroup;
}

function trackChanges(){
	var orgGroup = this._orgGroup;
	var tracker = this._tracker;
	var viewing = this._viewing;

	if(!orgGroup || !viewing) return;

	tracker.off();
	tracker.on("mqtt:orggroup/" + orgGroup + "/users/added", addUser.bind(this));
	tracker.on("mqtt:orggroup/" + orgGroup + "/users/removed", removeUser.bind(this));
}

function addUser(data){
	var who = data.who || data;
	var list = this._rawList;
	var newList = list.concat(who);
	this.addPeople(who);
	this._rawList = newList;
	this.recalculate();
}

function removeUser(data){
	var who = data.who || data;
	var list = this._rawList;
	var newList = list.filter(function(user){
		return user !== who;
	});
	this._rawList = newList;
	this.recalculate();
}

function reset(){
	this._viewing = false;
	this._page = 0;
	this._end = false;
	this._query = "";
	this._rawList = [];
	this._tracker.off();

	this.push({
		list: [],
		end: false,
		token: null,
		query: ""
	});
}

function handle_group_loaded({group}){
	this._manageGroup = group;
	if(!this._viewing) return;
	this._page = 0;
	var page = this._page;
	var query = this._query;
	this.api.org.users.listByManageGroup(query, group, page)
		.then(handle_users_search.bind(this))
		.then(trackManageGroupChanges.bind(this));
}

function trackManageGroupChanges(){
	var orgGroup = this._orgGroup;
	var tracker = this._tracker;
	var viewing = this._viewing;
	var manageGroup = this._manageGroup;

	if(!orgGroup || !viewing || !manageGroup) return;

	tracker.off();
	tracker.on(`mqtt:orggroup/${orgGroup}/managegroup/${manageGroup}/patient/added`, addUser.bind(this));
	tracker.on(`mqtt:orggroup/${orgGroup}/managegroup/${manageGroup}/patient/removed`, removeUser.bind(this));
}

function handle_group_cleared(){
	this._manageGroup = null;
	if(!this._viewing) return;
	this._page = 0;
	var page = this._page;
	var query = this._query;
	this.api.org.users.list(query, page)
		.then(handle_users_search.bind(this))
		.then(trackChanges.bind(this));
}

function handle_intiate_control(userId){
	this.extend({
		initiateControlTarget: userId
	});
}